<!-- Progress Line -->
<div class="completeline" [style.width]="scrollProgress"></div>

<!-- Header -->
<app-header></app-header>

<!-- Main Container -->
<div class="container mx-auto px-4 py-6 flex flex-col lg:flex-row gap-6">
    <!-- Left Sidebar -->
    <aside class="lg:w-1/4 hidden lg:block">
        <div class="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm mb-6 sticky top-20">
            <!-- Writer Profile -->
            <div class="flex items-center space-x-4 mb-4">
                <div class="bg-gray-200 dark:bg-gray-700 w-16 h-16 rounded-full flex items-center justify-center overflow-hidden">
                    <ng-container *ngIf="storyDetail?.author_profile && !hideAuthorImage; else authorInitialTpl">
                        <img [src]="storyImgPath + storyDetail.author_profile" 
                             (error)="hideAuthorImage = true"
                             alt="Author Image" 
                             class="w-full h-full object-cover">
                    </ng-container>
                    
                    <ng-template #authorInitialTpl>
                        <span class="text-2xl text-gray-500 dark:text-gray-400">
                            {{ storyDetail?.author_name?.charAt(0) || 'U' }}
                        </span>
                    </ng-template>
                </div>
                <div>
                    <h3 class="font-bold text-lg">{{ storyDetail?.author_name || 'Unknown Author' }}</h3>
                    <p class="text-sm text-gray-500 dark:text-gray-400">{{ formatCount(followerCount) }} {{t('FOLLOWERS')}}</p>
                </div>
            </div>
            
            <!-- Follow Button -->
            

            <button
  *ngIf="canShowFollowButton"
  (click)="toggleFollow()"
  [ngClass]="{
                    'bg-wattpad-primary text-white': !isFollowing,
                    'bg-gray-100 dark:bg-gray-700 text-wattpad-primary border border-wattpad-primary': isFollowing
                }"
                class="w-full px-4 py-2 rounded-full text-sm font-medium hover:opacity-90 transition-all mb-4">
  {{ isFollowing ? 'Unfollow' : 'Follow' }}
</button>
            
            <!-- Share Buttons -->
            <div class="mb-4">
                <h4 class="font-medium mb-2 text-gray-700 dark:text-gray-300">{{t('SHARE_THIS_STORY')}}</h4>
                <div class="flex space-x-2">
                    <button (click)="shareOnFacebook($event)" class="w-10 h-10 bg-blue-600 text-white rounded-full hover:bg-blue-700 flex items-center justify-center transition-colors">
                        <i class="fab fa-facebook-f"></i>
                    </button>
                    <button (click)="shareOnTwitter()" class="w-10 h-10 bg-blue-400 text-white rounded-full hover:bg-blue-500 flex items-center justify-center transition-colors">
                        <i class="fab fa-twitter"></i>
                    </button>
                    <button (click)="shareOnWhatsApp($event)" class="w-10 h-10 bg-green-500 text-white rounded-full hover:bg-green-600 flex items-center justify-center transition-colors">
                        <i class="fab fa-whatsapp"></i>
                    </button>
                </div>
            </div>
            
            <!-- Audio Player -->
            <div class="mb-4" *ngIf="storyContent?.audio">
                <h4 class="font-medium mb-2 text-gray-700 dark:text-gray-300">{{t('LISTEN_TO_THIS_STORY')}}</h4>
                <div class="audio-player bg-gradient-to-r from-wattpad-primary to-pink-500 p-3 rounded-xl">
                    <div class="flex items-center justify-between text-white">
                        <button class="play-pause w-10 h-10 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors" (click)="toggleAudioPlayback()">
                            <i class="fas" [ngClass]="{'fa-play': !isPlaying, 'fa-pause': isPlaying}"></i>
                        </button>
                        <div class="flex-1 mx-4">
                            <div class="w-full bg-white/30 h-1 rounded-full cursor-pointer" (click)="seekAudio($event)">
                                <div class="bg-white h-1 rounded-full transition-all duration-300" [style.width]="progressBarWidth"></div>
                            </div>
                        </div>
                        <span class="text-xs font-medium">{{ currentTimeDisplay }} / {{ durationDisplay }}</span>
                        <audio #audioPlayer (timeupdate)="updateProgressBar()" (ended)="onAudioEnded()">
                            <source [src]="storyContent.audio" type="audio/mpeg">
                        </audio>
                    </div>
                </div>
            </div>
            
            <!-- Ad Space -->
            <div class="bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800 h-40 w-full rounded-lg flex flex-col items-center justify-center mt-4 border border-dashed border-gray-300 dark:border-gray-600">
                <i class="fas fa-ad text-gray-400 dark:text-gray-500 text-2xl mb-2"></i>
                <span class="text-gray-500 dark:text-gray-400 text-sm">Advertisement</span>
            </div>
        </div>
    </aside>

    <!-- Main Content Area -->
    <main class="lg:w-2/4">
        <article class="bg-white dark:bg-gray-800 rounded-2xl p-6 lg:p-8 shadow-sm mb-6">
            <!-- Story Header -->
            <div class="flex justify-between items-start mb-6">
                <div class="flex-1">
                    <h1 class="text-2xl lg:text-3xl font-bold mb-3 text-gray-800 dark:text-white" *ngIf="storyContent && !isLoading">
                        {{storyContent.title}}
                    </h1>
                    
                    <!-- Rating System -->
                    <div class="flex items-center flex-wrap gap-2 mb-4">
                        <div class="star-rating flex space-x-1">
                            <ng-container *ngFor="let star of [5,4,3,2,1]; let i = index">
                                <!-- Option 1: Using radio buttons (properly working) -->
                                <input 
                                    type="radio"
                                    [id]="'star' + star"
                                    name="rating"
                                    [value]="star"
                                    [checked]="userRating === star"
                                    (change)="submitRating(star)" 
                                    class="hidden"
                                />
                                
                                <!-- Star label/icon -->
                                <label 
                                    [for]="'star' + star" 
                                    class="cursor-pointer"
                                    (mouseenter)="onStarHover(star)"
                                    (mouseleave)="onStarLeave()">
                                    
                                    <i class="fas fa-star text-lg transition-all duration-200"
                                       [ngClass]="{
                                         'text-yellow-400': star <= (hoverRating || userRating),
                                         'text-gray-300 dark:text-gray-600': star > (hoverRating || userRating)
                                       }">
                                    </i>
                                </label>
                            </ng-container>
                        </div>
                        
                        <!-- Average Rating -->
                        <span class="text-sm text-gray-600 dark:text-gray-400 ml-2">
                            ({{ userRating }} {{t('FORM')}} {{ totalRatings }} {{t('RATINGS')}})
                        </span>
                    </div>
                </div>
                
                <!-- Fullscreen Button -->
                <button (click)="toggleFullscreen()" 
                        class="ml-4 p-3 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                        [title]="isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'">
                    <i class="fas" [ngClass]="{'fa-expand': !isFullscreen, 'fa-compress': isFullscreen}"></i>
                </button>
            </div>
            
            <!-- Video Embed -->
            <div class="video-container mb-8 rounded-xl overflow-hidden shadow-lg" *ngIf="storyContent && storyContent.video_url && !isLoading">
                <video width="100%" height="auto" controls class="w-full" poster="https://via.placeholder.com/800x450/FF3366/ffffff?text=Video+Preview">
                    <source [src]="storyContent.video_url" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
            
            <!-- Story Text -->
            <div class="story-content text-gray-700 dark:text-gray-300 text-lg leading-relaxed space-y-6"
                 #storyTextEl
                 id="storyContent"
                 *ngIf="storyContent && !isLoading"
                 [innerHTML]="storyContent.content">
            </div>
            
            <!-- Loading State -->
            <div *ngIf="isLoading" class="py-12 text-center">
                <div class="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-wattpad-primary mb-4"></div>
                <p class="text-gray-600 dark:text-gray-400">Loading story...</p>
            </div>
            
            <!-- Next Part CTA -->
            <div class="mt-10 text-center" *ngIf="partsLoaded && !isLastPart()">
                <!-- Login Required Message for non-logged in users -->
                <div *ngIf="!isUserLoggedIn" class="mb-6 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl">
                    <div class="flex items-center justify-center">
                        <i class="fas fa-user-lock text-yellow-500 mr-3"></i>
                        <p class="text-yellow-700 dark:text-yellow-300">Login required to continue reading</p>
                    </div>
                    <button (click)="navigateToLogin()" 
                            class="mt-3 px-6 py-2 bg-wattpad-primary text-white rounded-full hover:bg-[#E5274B] transition-colors">
                        Login Now
                    </button>
                </div>
                
                <!-- Next Part Button for logged in users -->
                <button *ngIf="isUserLoggedIn"
                        class="bg-gradient-to-r from-wattpad-primary to-pink-500 text-white px-10 py-4 rounded-full font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300"
                        (click)="continueToNextPart()"
                        [disabled]="paymentProcessing"
                        [class.opacity-50]="paymentProcessing"
                        [class.cursor-not-allowed]="paymentProcessing">
                    
                    <div class="flex items-center justify-center">
                        <span *ngIf="!paymentProcessing" class="flex items-center">
                            {{t('CONTINUE_NEXT')}}
                            <i class="fas fa-arrow-right ml-3 text-lg animate-pulse"></i>
                        </span>
                        
                        <span *ngIf="paymentProcessing" class="flex items-center">
                            <i class="fas fa-spinner fa-spin mr-3"></i>
                            Processing Payment...
                        </span>
                    </div>
                    
                    <!-- Episode Price Badge -->
                    <div *ngIf="getNextEpisodePrice() > 0" 
                         class="mt-2 text-sm bg-white/20 px-3 py-1 rounded-full inline-block">
                        <i class="fas fa-crown mr-1"></i>
                        ₹{{ getNextEpisodePrice() }}
                    </div>
                    
                    <!-- Free Badge - Show if price is 0 -->
                    <div *ngIf="getNextEpisodePrice() === 0 && !isLastPart()" 
                         class="mt-2 text-sm bg-green-500/20 text-white-700 px-3 py-1 rounded-full inline-block">
                        <i class="fas fa-unlock mr-1"></i>
                        Free Episode
                    </div>
                </button>
                
                <!-- Balance Info - Show only for logged in users -->
                <p *ngIf="isUserLoggedIn" class="text-sm text-gray-600 dark:text-gray-400 mt-3">
                    <span *ngIf="userReaderBalance === 0">Loading balance...</span>
                    <span *ngIf="userReaderBalance > 0">Your balance: ₹{{ userReaderBalance }}</span>
                </p>
                
                <!-- Login Status -->
                <p *ngIf="!isUserLoggedIn" class="text-sm text-gray-600 dark:text-gray-400 mt-3">
                    <i class="fas fa-user-lock mr-1"></i> Not logged in
                </p>
            </div>

            <!-- End of Story -->
            <div *ngIf="allParts.length > 0 && isLastPart()" class="mt-12 text-center py-8 border-t border-gray-200 dark:border-gray-700">
                <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-green-400 to-blue-500 mb-4">
                    <i class="fas fa-check text-white text-2xl"></i>
                </div>
                <h3 class="text-2xl font-bold text-gray-800 dark:text-white mb-2">--- {{t('END_STORY')}} ---</h3>
                <p class="text-gray-600 dark:text-gray-400">You've completed all {{ allParts.length }} parts of this story!</p>
                
                <!-- Return to Story Page -->
                <button (click)="goBackToStory()" 
                        class="mt-6 px-6 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                    <i class="fas fa-book mr-2"></i>
                    Back to Story Overview
                </button>
            </div>

            <!-- Error Message -->
            <div *ngIf="errorMessage" class="mt-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl">
                <div class="flex items-center">
                    <i class="fas fa-exclamation-triangle text-red-500 mr-3"></i>
                    <p class="text-red-700 dark:text-red-400">{{ errorMessage }}</p>
                </div>
            </div>
        </article>

        <!-- Comments Section -->
        <app-comment-section *ngIf="storyId !== null" [storyId]="storyId"></app-comment-section>
    </main>

    <!-- Right Sidebar (Related Stories) -->
    <aside class="lg:w-1/4 hidden lg:block">
        <div class="sticky top-20 space-y-6">
            <!-- Related Stories Section -->
            <div class="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm">
                <h3 class="font-bold text-lg mb-4 text-gray-800 dark:text-white">Related Stories</h3>
                <div class="space-y-4">
                    <div *ngFor="let related of relatedStories" 
                         class="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors cursor-pointer"
                         (click)="navigateToRelatedStory(related)">
                        
                        <!-- Story Image or Icon -->
                        <div class="w-12 h-12 rounded-lg flex items-center justify-center overflow-hidden flex-shrink-0"
                             [class.bg-gradient-to-r]="!related.story_image"
                             [class.from-purple-400]="!related.story_image"
                             [class.to-pink-400]="!related.story_image">
                            <img *ngIf="related.story_image" 
                                 [src]="related.story_image" 
                                 alt="{{ related.title }}"
                                 class="w-full h-full object-cover">
                            <i *ngIf="!related.story_image" class="fas fa-book text-white"></i>
                        </div>
                        
                        <!-- Story Details -->
                        <div class="flex-1 min-w-0">
                            <h4 class="font-medium text-sm line-clamp-1 text-gray-800 dark:text-white">
                                {{ related.title }}
                            </h4>
                            <p class="text-xs text-gray-500 dark:text-gray-400 line-clamp-1">
                                {{ related.author }}
                            </p>
                            <div class="flex items-center mt-1">
                                <i class="fas fa-star text-yellow-400 text-xs mr-1"></i>
                                <span class="text-xs text-gray-600 dark:text-gray-400">
                                    {{ getFormattedRating(related.rating) }}
                                </span>
                                <span class="mx-1 text-gray-400">•</span>
                                <i class="fas fa-eye text-gray-400 text-xs mr-1"></i>
                                <span class="text-xs text-gray-600 dark:text-gray-400">
                                    {{ formatCount(related.views) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- No Related Stories Message -->
                <div *ngIf="relatedStories.length === 0" class="text-center py-4 text-gray-500">
                    <i class="fas fa-book-open text-2xl mb-2"></i>
                    <p class="text-sm">No related stories found</p>
                </div>
            </div>
            
            <!-- Quick Stats -->
            <div class="bg-gradient-to-r from-wattpad-primary/10 to-pink-500/10 dark:from-wattpad-primary/20 dark:to-pink-500/20 rounded-xl p-4">
                <h3 class="font-bold text-lg mb-4 text-gray-800 dark:text-white">Reading Stats</h3>
                <div class="space-y-3">
                    <div class="flex justify-between items-center">
                        <span class="text-gray-600 dark:text-gray-300">Current Part</span>
                        <span class="font-bold">{{ getCurrentPartNumber() }}/{{ allParts.length }}</span>
                    </div>
                    <div class="flex justify-between items-center">
                        <span class="text-gray-600 dark:text-gray-300">Reading Time</span>
                        <span class="font-bold">{{ calculateReadingTime() }} min</span>
                    </div>
                    <div class="flex justify-between items-center">
                        <span class="text-gray-600 dark:text-gray-300">Published</span>
                        <span class="font-bold">{{ formatDate(storyDetail?.created_at) }}</span>
                    </div>
                </div>
            </div>
            
            
        </div>
    </aside>
</div>

<!-- FULLSCREEN READER -->
<div id="fullscreenReader" 
     class="fullscreen-reader"
     [class.active]="isFullscreen"
     [class.dark]="readerMode === 'dark'" 
     [class.reading-mode]="readerMode === 'reading'">
    
    <!-- Progress Bar in Fullscreen -->
    <div class="fullscreen-progress" [style.width]="scrollProgress"></div>
    
    <!-- Fullscreen Header -->
    <div class="fullscreen-header">
        <div class="container mx-auto max-w-4xl px-6">
            <div class="flex justify-between items-center py-4">
                <!-- Story Info -->
                <div class="flex items-center space-x-4">
                    <button (click)="toggleFullscreen()" 
                            class="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
                        <i class="fas fa-chevron-left text-xl"></i>
                    </button>
                    <div>
                        <h1 class="text-xl font-bold truncate max-w-md">{{ storyContent?.title }}</h1>
                        <p class="text-sm text-gray-500 dark:text-gray-400">
                            Part {{ getCurrentPartNumber() }} of {{ allParts.length }}
                        </p>
                    </div>
                </div>
                
                <!-- Quick Actions -->
                <div class="flex items-center space-x-2">
                    <!-- Audio Button -->
                    <button *ngIf="storyContent?.audio" 
                            (click)="toggleAudioPlayback()"
                            [class.bg-wattpad-primary]="isPlaying"
                            class="p-3 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                            [title]="isPlaying ? 'Pause Audio' : 'Play Audio'">
                        <i class="fas" [ngClass]="{'fa-volume-up': !isPlaying, 'fa-volume-mute': isPlaying}"></i>
                    </button>
                    
                    <!-- Fullscreen Exit -->
                    <button (click)="toggleFullscreen()" 
                            class="p-3 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                            title="Exit Fullscreen">
                        <i class="fas fa-times text-lg"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Fullscreen Content -->
    <div class="fullscreen-content">
        <div class="container mx-auto max-w-4xl px-6 py-8">
            <!-- Video in Fullscreen -->
            <div class="video-container mb-8 rounded-xl overflow-hidden" *ngIf="storyContent && storyContent.video_url">
                <video width="100%" height="auto" controls autoplay>
                    <source [src]="storyContent.video_url" type="video/mp4">
                </video>
            </div>
            
            <!-- Story Content -->
            <div id="readerContent" 
                 class="story-text-fullscreen"
                 [style.fontSize.px]="fontSize * 18"
                 [innerHTML]="storyContent?.content">
            </div>
            
            <!-- NEXT PART BUTTON IN FULLSCREEN -->
            <div class="next-part-fullscreen mt-12 text-center" *ngIf="partsLoaded && !isLastPart()">
                <div class="bg-gradient-to-r from-black/5 to-transparent dark:from-white/5 p-8 rounded-2xl">
                    <h3 class="text-2xl font-bold mb-4">Continue Reading?</h3>
                    <p class="text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto">
                        You're {{ getReadPercentage() }}% through this part. Ready for the next chapter?
                    </p>
                    
                    <!-- Login Required Message -->
                    <div *ngIf="!isUserLoggedIn" class="mb-6 p-4 bg-yellow-900/20 border border-yellow-800 rounded-xl">
                        <div class="flex items-center justify-center">
                            <i class="fas fa-user-lock text-yellow-400 mr-3"></i>
                            <p class="text-yellow-300">Login required to continue reading</p>
                        </div>
                        <button (click)="navigateToLogin()" 
                                class="mt-3 px-6 py-2 bg-wattpad-primary text-white rounded-full hover:bg-[#E5274B] transition-colors">
                            Login Now
                        </button>
                    </div>
                    
                    <!-- Next Part Button for logged in users -->
                    <button *ngIf="isUserLoggedIn"
                            (click)="continueToNextPart()"
                            [disabled]="paymentProcessing"
                            class="bg-gradient-to-r from-wattpad-primary to-pink-500 text-white px-12 py-4 rounded-full font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 text-lg"
                            [class.opacity-50]="paymentProcessing">
                        
                        <div class="flex items-center justify-center space-x-3">
                            <span *ngIf="!paymentProcessing">
                                Continue to Part {{ getCurrentPartNumber() + 1 }}
                            </span>
                            <span *ngIf="paymentProcessing">
                                <i class="fas fa-spinner fa-spin mr-2"></i> Processing...
                            </span>
                            <i class="fas fa-arrow-right text-xl animate-bounce"></i>
                        </div>
                        
                        <!-- Price Info - Only show if price > 0 -->
                        <div *ngIf="getNextEpisodePrice() > 0" class="mt-3 text-sm bg-white/20 px-4 py-1 rounded-full inline-block">
                            <i class="fas fa-crown mr-2"></i>
                            Premium Episode - ₹{{ getNextEpisodePrice() }}
                        </div>
                        
                        <!-- Free Badge -->
                        <div *ngIf="getNextEpisodePrice() === 0" class="mt-3 text-sm bg-green-500/20 text-white-700 px-4 py-1 rounded-full inline-block">
                            <i class="fas fa-unlock mr-2"></i>
                            Free Episode
                        </div>
                    </button>
                    
                    <!-- Balance Info in Fullscreen (only for logged in) -->
                    <p *ngIf="isUserLoggedIn" class="text-sm text-gray-600 dark:text-gray-400 mt-3">
                        <span *ngIf="userReaderBalance === 0">Loading balance...</span>
                        <span *ngIf="userReaderBalance > 0">Your balance: ₹{{ userReaderBalance }}</span>
                    </p>
                    
                    <!-- Login Status in Fullscreen -->
                    <p *ngIf="!isUserLoggedIn" class="text-sm text-gray-400 dark:text-gray-500 mt-3">
                        <i class="fas fa-user-lock mr-1"></i> Not logged in
                    </p>
                    
                    <!-- Skip Option -->
                    <button (click)="toggleFullscreen()" 
                            class="mt-4 text-gray-500 dark:text-gray-400 hover:text-wattpad-primary dark:hover:text-wattpad-primary transition-colors">
                        Not now, read later
                    </button>
                </div>
            </div>
            
            <!-- End of Story in Fullscreen -->
            <div *ngIf="allParts.length > 0 && isLastPart()" class="text-center py-16">
                <div class="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-r from-green-400 to-blue-500 mb-6">
                    <i class="fas fa-trophy text-white text-3xl"></i>
                </div>
                <h2 class="text-3xl font-bold mb-4">Story Completed! 🎉</h2>
                <p class="text-gray-600 dark:text-gray-400 text-lg mb-8 max-w-md mx-auto">
                    Congratulations! You've finished all {{ allParts.length }} parts of this amazing story.
                </p>
                
                <div class="flex justify-center space-x-4">
                    <button (click)="toggleFullscreen()" 
                            class="px-8 py-3 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
                        <i class="fas fa-times mr-2"></i>
                        Exit Fullscreen
                    </button>
                    
                    <button (click)="goBackToStory()" 
                            class="px-8 py-3 bg-gradient-to-r from-wattpad-primary to-pink-500 text-white rounded-full hover:shadow-lg transition-all">
                        <i class="fas fa-book mr-2"></i>
                        Back to Story
                    </button>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Reader Controls (Bottom Fixed) -->
    <div id="readerControls" 
         class="reader-controls"
         [class.dark]="readerMode === 'dark'"
         [class.reading-mode]="readerMode === 'reading'">
        
        <div class="container mx-auto max-w-4xl px-6">
            <div class="flex items-center justify-between">
                <!-- Left Controls -->
                <div class="flex items-center space-x-4">
                    <!-- Reading Modes -->
                    <div class="flex bg-gray-100 dark:bg-white-800 rounded-full p-1">
                        <button (click)="changeReaderMode('light')" 
                                [class.bg-white]="readerMode === 'light'"
                                class="p-2 rounded-full transition-all"
                                title="Light Mode">
                            <i class="fas fa-sun text-gray-700"></i>
                        </button>
                        <button (click)="changeReaderMode('dark')" 
                                [class.bg-gray-800]="readerMode === 'dark'"
                                [class.text-white]="readerMode === 'dark'"
                                class="p-2 rounded-full transition-all"
                                title="Dark Mode">
                            <i class="fas fa-moon"></i>
                        </button>
                        <button (click)="changeReaderMode('reading')" 
                                [class.bg-amber-100]="readerMode === 'reading'"
                                class="p-2 rounded-full transition-all"
                                title="Reading Mode">
                            <i class="fas fa-book-open text-amber-700"></i>
                        </button>
                    </div>
                    
                    <!-- Font Size -->
                    <div class="flex items-center space-x-2 bg-gray-100 dark:bg-white-800 rounded-full px-3 py-1">
                        <button (click)="adjustFontSize('decrease')" 
                                class="p-1 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-full"
                                title="Decrease Font">
                            <i class="fas fa-minus"></i>
                        </button>
                        <span class="text-sm font-medium w-12 text-center">{{ fontSize.toFixed(1) }}x</span>
                        <button (click)="adjustFontSize('increase')" 
                                class="p-1 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-full"
                                title="Increase Font">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                
                <!-- Center - Progress -->
                <div class="flex items-center space-x-4">
                    <span class="text-sm">{{ getCurrentPartNumber() }}/{{ allParts.length }}</span>
                    <div class="w-32 bg-gray-200 dark:bg-gray-700 h-1 rounded-full">
                        <div class="bg-wattpad-primary h-1 rounded-full" 
                             [style.width.%]="(getCurrentPartNumber() / allParts.length) * 100">
                        </div>
                    </div>
                </div>
                
                <!-- Right Controls -->
                <div class="flex items-center space-x-2">
                    <!-- Previous Chapter -->
                    <button *ngIf="!isFirstPart()" 
                            (click)="goToPreviousPart()"
                            class="p-3 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                            title="Previous Part">
                        <i class="fas fa-arrow-left"></i>
                    </button>
                    
                    <!-- Next Chapter Button (in controls) -->
                    <button *ngIf="!isLastPart() && isUserLoggedIn" 
                            (click)="continueToNextPart()"
                            [disabled]="paymentProcessing"
                            class="px-5 py-2 bg-wattpad-primary text-white rounded-full hover:bg-[#E5274B] transition-colors flex items-center space-x-2"
                            [class.opacity-50]="paymentProcessing">
                        <span>Next</span>
                        <i class="fas fa-arrow-right"></i>
                    </button>
                    
                    <!-- Login Button for non-logged in -->
                    <button *ngIf="!isLastPart() && !isUserLoggedIn" 
                            (click)="navigateToLogin()"
                            class="px-5 py-2 bg-yellow-500 text-white rounded-full hover:bg-yellow-600 transition-colors flex items-center space-x-2">
                        <i class="fas fa-sign-in-alt"></i>
                        <span>Login</span>
                    </button>
                    
                    <!-- Exit Fullscreen -->
                    <button (click)="toggleFullscreen()" 
                            class="p-3 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                            title="Exit Fullscreen">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Bottom Navigation -->
<nav class="bottom-nav fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 lg:hidden z-40">
    <div class="flex justify-around items-center py-3">
        <!-- Previous -->
        <button *ngIf="!isFirstPart()" 
                (click)="goToPreviousPart()"
                class="flex flex-col items-center p-2 text-gray-600 dark:text-gray-400 hover:text-wattpad-primary">
            <i class="fas fa-arrow-left text-xl"></i>
            <span class="text-xs mt-1">Previous</span>
        </button>
        
        <!-- Fullscreen -->
        <button (click)="toggleFullscreen()" 
                class="flex flex-col items-center p-2 text-gray-600 dark:text-gray-400 hover:text-wattpad-primary">
            <i class="fas" [ngClass]="{'fa-expand': !isFullscreen, 'fa-compress': isFullscreen}"></i>
            <span class="text-xs mt-1">{{ isFullscreen ? 'Exit' : 'Full' }}</span>
        </button>
        
        <!-- Next -->
        <button *ngIf="!isLastPart()" 
                (click)="continueToNextPart()"
                [disabled]="paymentProcessing || !isUserLoggedIn"
                class="flex flex-col items-center p-2"
                [ngClass]="{
                  'text-wattpad-primary': isUserLoggedIn && !paymentProcessing,
                  'text-gray-400': !isUserLoggedIn || paymentProcessing,
                  'text-yellow-500': !isUserLoggedIn
                }">
            <i class="fas fa-arrow-right text-xl"></i>
            <span class="text-xs mt-1">Next</span>
            <span *ngIf="!isUserLoggedIn" class="text-[10px] text-yellow-500">Login</span>
        </button>
        
        <!-- Library -->
        <button (click)="addToLibrary()" 
                class="flex flex-col items-center p-2 text-gray-600 dark:text-gray-400 hover:text-wattpad-primary">
            <i class="fas" [ngClass]="{'fa-bookmark': !isInLibrary, 'fas fa-bookmark': isInLibrary}"></i>
            <span class="text-xs mt-1">Library</span>
        </button>
        
        <!-- Share -->
        <button (click)="shareStory()" 
                class="flex flex-col items-center p-2 text-gray-600 dark:text-gray-400 hover:text-wattpad-primary">
            <i class="fas fa-share-alt text-xl"></i>
            <span class="text-xs mt-1">Share</span>
        </button>
    </div>
</nav>

<!-- Payment Processing Overlay -->
<div *ngIf="paymentProcessing" class="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
    <div class="bg-white dark:bg-gray-800 rounded-2xl p-8 max-w-md mx-4 text-center">
        <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-wattpad-primary to-pink-500 mb-4">
            <i class="fas fa-lock text-white text-2xl"></i>
        </div>
        <h3 class="text-xl font-bold mb-2">Processing Payment</h3>
        <p class="text-gray-600 dark:text-gray-400 mb-6">
            Please wait while we process your payment for the next episode...
        </p>
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-wattpad-primary"></div>
        <p class="text-sm text-gray-500 dark:text-gray-500 mt-4">Do not close this window</p>
    </div>
</div>

<!-- Payment Popup (Balance Warning) -->
<div *ngIf="showPaymentPopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-2xl p-6 w-full max-w-md mx-auto shadow-xl">
        <!-- Header with Icon -->
        <div class="text-center mb-6">
            <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i class="fas fa-wallet text-red-500 text-2xl"></i>
            </div>
            <h3 class="text-2xl font-bold text-gray-800 mb-2">Insufficient Balance</h3>
            <p class="text-gray-600">Add money to your wallet to read this episode</p>
        </div>

        <!-- Balance Card -->
        <div class="bg-gradient-to-r from-red-50 to-orange-50 rounded-xl p-5 mb-6 border border-red-100">
            <div class="grid grid-cols-2 gap-4 text-center">
                <div>
                    <p class="text-sm text-gray-600 mb-1">Episode Price</p>
                    <p class="text-xl font-bold text-gray-800">₹{{paymentPopupData.episodePrice || 0}}</p>
                </div>
                <div>
                    <p class="text-sm text-gray-600 mb-1">Your Balance</p>
                    <p class="text-xl font-bold text-gray-800">₹{{paymentPopupData.currentBalance || 0}}</p>
                </div>
            </div>
            <div class="mt-4 pt-4 border-t border-red-200">
                <div class="flex justify-between items-center">
                    <span class="text-sm font-medium text-gray-700">Amount Needed:</span>
                    <span class="text-lg font-bold text-red-600">₹{{paymentPopupData.shortfall || 0}}</span>
                </div>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex gap-3">
            <button 
                (click)="closePaymentPopup()"
                class="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-xl font-medium hover:bg-gray-50 transition-colors">
                Cancel
            </button>
            <button 
                (click)="navigateToWallet()"
                class="flex-1 px-6 py-3 bg-gradient-to-r from-wattpad-primary to-[#E5274B] text-white rounded-xl font-medium hover:shadow-lg transition-all flex items-center justify-center">
                <i class="fas fa-bolt mr-2"></i>
                Recharge Now
            </button>
        </div>
    </div>
</div>